<script lang="ts">
  import { getContext } from 'svelte';
  import { TextStack } from '@squareup/public-web-design-system';
  import { DesignSystem as DesignSystemEnum } from '$lib/helpers/design-system';
  import type { LeadFormProps } from './types';

  export let title: LeadFormProps['title'];
  export let body: LeadFormProps['body'];
  export let introHeadingLevel: LeadFormProps['introHeadingLevel'];
  export let introBodyFontSize: LeadFormProps['introBodyFontSize'];
  export let introTextAlignment: LeadFormProps['introTextAlignment'];

  const isPWDSEnabled = getContext<DesignSystemEnum>('designSystem') === DesignSystemEnum.PublicWebDesignSystem;

  const resolvedAlignment = introTextAlignment === 'justify' ? 'left' : introTextAlignment;
</script>

{#if isPWDSEnabled}
  <TextStack
    headingText={title}
    headingVariant="200"
    bodyText={body}
    bodyVariant="100-r"
    alignment={resolvedAlignment}
  />
{:else}
  <div
    class="LeadFormIntroPartial intro font-size-{introBodyFontSize}"
    class:centered={introTextAlignment === 'center'}
    style:text-align={introTextAlignment}
  >
    {#if title}
      <h2 class="balance-text {introHeadingLevel}">
        {title}
      </h2>
    {/if}
    {#if body}
      {@html body}
    {/if}
  </div>
{/if}

<style lang="scss">
  @layer standard-components {
    .intro {
      max-width: 40em;
      margin-left: var(--space-none);
      margin-right: var(--space-none);

      &.centered {
        margin-left: var(--space-auto);
        margin-right: var(--space-auto);
      }
    }

    .font-size {
      &-base {
        line-height: var(--line-height-body);
        font-size: var(--font-size-body);
      }
      &-tiny {
        line-height: var(--line-height-body-extra-small);
        font-size: var(--font-size-body-extra-small);
      }
      &-small {
        line-height: var(--line-height-body-extra-small);
        font-size: var(--font-size-body-extra-small);
      }
      &-normal {
        line-height: var(--line-height-body);
        font-size: var(--font-size-body);
      }
      &-large {
        line-height: var(--line-height-body-large);
        font-size: var(--font-size-body-large);
      }
    }

    :global {
      .LeadFormSection--is-pwds {
        .TextStack {
          margin-bottom: var(--space-30);
        }
      }
    }
  }
</style>
